import Vue from 'vue'
import App from './App.vue'
import Components from './components'
import router from './router'
import VConsole from 'vconsole'

Vue.config.productionTip = false
Vue.use(Components)

if (process.env.NODE_ENV === 'development') {
  new VConsole()
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
